<template>
  <div>
    <v-data-table
      :headers="monthItemDataTableHeaders"
      :items="monthList"
      class="elevation-1 ma-5"
      :no-data-text="$t('common_no_data')"
      :no-results-text="$t('common_no_results')"
      item-key="Number"
      disable-pagination
      hide-default-footer
    >
      <template v-slot:[`item.Edit`]="{ item }">
        <v-icon
          small
          v-if="!(monthList.length === 1)"
          @click="confirmDeleteMonthItem(item)"
          :disabled="isAllTextFieldDisable"
        >
          mdi-delete
        </v-icon>
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  name: 'ChangeDetailMonthItem',
  props: {
    monthList: {
      type: Array
    },
    isAllTextFieldDisable: {
      type: Boolean
    }
  },
  data: () => ({}),
  mounted () {},
  watch: {},
  computed: {
    monthItemDataTableHeaders () {
      return [
        { text: this.$t('quotation_item_number'), align: 'start', value: 'Number' },
        { text: this.$t('quotation_item_name'), align: 'start', value: 'Name' },
        { text: this.$t('month_quantity'), align: 'start', value: 'Quantity' },
        { text: this.$t('quotation_item_month_number'), align: 'start', value: 'MonthNumber' },
        {
          text: this.$t('quotation_item_rent_warranty_period'),
          align: 'end',
          value: 'RentWarrantyPeriod'
        },
        { text: '收費方式', align: 'center', value: 'PayType' },
        { text: this.$t('common_edit'), align: 'center', value: 'Edit', sortable: false }
      ]
    }
  },
  methods: {
    confirmDeleteMonthItem (item) {
      this.$emit('confirmDeleteMonthItem', item)
    }
  }
}
</script>
